//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from "vuex";
export default {
  name: "Alvarado",
  data() {
    return {
      form: {
        anorexia: "0",
        nausea: "0",
        abdoPain: "0",

        tenderness: "0",
        rebounds: "0",
        fever: "0",

        leuko: "0",
        neutro: "0",
      },
      hasScore: false,
      disabled: false,
      defaultJson: {
        "RLQ Rebound Pain": "右下腹反跳痛",
        "Shift to the left of neutrophils": "中性粒细胞核左移",
        Symptoms: "症状",
        "Probable Appendicitis": "阑尾炎可能",
        "WBC > 10'000 c/mm³": "WBC > 10 x 10⁹/L",
        "Very Probable Appendicitis": "阑尾炎高度可能",
        "Lab Values": "实验室指标",
        "Temperature > 37.3 °C": "体温 > 37.3 °C",
        Signs: "体征",
        "Nausea / Vomiting": "恶心 / 呕吐",
        "RLQ Tenderness": "右下腹压痛",
        "Migratory RLQ Pain": "转移性右下腹痛",
        "Appendicitis unlikely": "阑尾炎可排除",
        "Possible Appendicitis": "阑尾炎可疑",
        Anorexia: "厌食",
      },
      major: 0,
      minor: 0,
    };
  },
  created() {
    this.hideLoad();
  },
  methods: {
    ...mapMutations(["hideLoad"]),
  },
  computed: {
    /** 计算主要标准 */
    score() {
      let self = this;
      let form = JSON.parse(JSON.stringify(self.form));
      let flag = true;
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false;
          } else {
            form[key] = Number(form[key]);
          }
        }
      }
      if (!flag) {
        self.hasScore = false;
        return "0";
      } else {
        // (leuko ? 2 : 0) + (tenderness ? 2 : 0) + (abdoPain ? 1 : 0) + (anorexia ? 1 : 0) + (nausea ? 1 : 0) + (rebounds ? 1 : 0) + (fever ? 1 : 0) + (neutro ? 1 : 0)
        let result =
          (form.leuko ? 2 : 0) +
          (form.tenderness ? 2 : 0) +
          (form.abdoPain ? 1 : 0) +
          (form.anorexia ? 1 : 0) +
          (form.nausea ? 1 : 0) +
          (form.rebounds ? 1 : 0) +
          (form.fever ? 1 : 0) +
          (form.neutro ? 1 : 0);
        self.hasScore = true;
        return String(result);
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Pedi/Alvarado.vue